var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.76211 16.5652V12.7489H3.41211V17.9152H14.6752V12.7489H13.3252V16.5652H4.76211Z",
    fill: "#39414A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2 7.19888H1.8C1.55147 7.19888 1.35 7.40035 1.35 7.64888V11.6141C1.35 11.8626 1.55147 12.0641 1.8 12.0641H16.2C16.4485 12.0641 16.65 11.8626 16.65 11.6141V7.64888C16.65 7.40035 16.4485 7.19888 16.2 7.19888ZM1.8 5.84888C0.805887 5.84888 0 6.65477 0 7.64888V11.6141C0 12.6082 0.805888 13.4141 1.8 13.4141H16.2C17.1941 13.4141 18 12.6082 18 11.6141V7.64888C18 6.65476 17.1941 5.84888 16.2 5.84888H1.8Z",
    fill: "#39414A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.19434 0H12.5951L14.4574 1.97185V5.13261H3.19434V0ZM4.54434 1.35V3.78261H13.1074V2.50858L12.0132 1.35H4.54434Z",
    fill: "#39414A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.0f9557b84fa359c851ea6ed2597896e4.svg";
export { ForwardRef as ReactComponent };